import { LANG } from "@/constants/Language";
import ContentLevel from "@/types/models/ContentLevel.interface";

export const findHighestLexileWithinRange = (
  sortedContentLevels: ContentLevel[],
  readingLevelLexileRange: number[],
  language: LANG,
) => {
  const [minLevelValue = 0, maxLevelValue = 0] = readingLevelLexileRange;

  const sortedLevelsWithinRange = sortedContentLevels.filter((level) => {
    if (language && level.language !== language) {
      return false;
    }

    return (
      level.raw_lexile >= minLevelValue && level.raw_lexile <= maxLevelValue
    );
  });

  const highestLexileThatFitsRange =
    sortedLevelsWithinRange[sortedLevelsWithinRange.length - 1];

  return highestLexileThatFitsRange;
};
